import { render } from "./NewPage.vue?vue&type=template&id=46f4efc0&scoped=true"
import script from "./NewPage.vue?vue&type=script&lang=js"
export * from "./NewPage.vue?vue&type=script&lang=js"

import "./NewPage.vue?vue&type=style&index=0&id=46f4efc0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46f4efc0"

export default script